export class EvidenciaOportunidad{
      name:  string
        type:  string
       ruta_archivo:string
       content: string;
       tipo:any
       fileArchivo: string;
 }